import { Link } from "react-router-dom";

const RefunfPolicy = () => (
  <>
    {/* Page Title Section */}
    <div className="wd-page-title page-title page-title-default title-size-default title-design-centered color-scheme-light">
      <div className="container">
        <h1 className="entry-title title">Refund and return policy</h1>
        <nav className="wd-breadcrumbs">
          <span typeof="v:Breadcrumb">
            <Link to="/" rel="v:url" property="v:title">
              Home
            </Link>
          </span>
          <span className="wd-delimiter"></span>
          <span className="wd-last">Refund</span>
        </nav>
      </div>
    </div>
    {/* Main Content Area for Privacy Policy */}
    <div className="wd-page-content main-page-wrapper">
      <h1 style={{ textAlign: "center", margin: "2rem" }}>
        Refund and Cancellation Policy
        <hr />
      </h1>
      <main
        className="wd-content-layout content-layout-wrapper container"
        role="main"
      >
        <p>
          We aim to provide a fair and transparent refund process for all course
          purchases made through our website. If you wish to cancel your course
          enrollment, you must submit a refund request within <b>5 days</b> of
          the purchase date.
          <br /> Refunds may be granted under specific circumstances, such as:
          <br />
          <br />
          Dissatisfaction with course content
          <br />
          Technical issues that prevent access to course materials
          <hr style={{ border: "2px solid #9D0FA4" }} />
          To request a refund, please contact our
          <b>customer support team</b> with your <b>order details</b> and a
          brief explanation of your reason for the request. <br />
          All refunds are subject to approval and will be processed within{" "}
          <b>14 days</b> from the date of approval. Please note:
          <br/><br/> Any applicable fees or
          charges may be deducted from the refund amount. <br />
          Refunds will be issued via the <b>original method of payment.</b>
          <br /> <br />
          For further assistance, feel free to reach out to our support team.
        </p>
      </main>
    </div>
  </>
);

export default RefunfPolicy;
